import { HttpErrorResponse } from '@angular/common/http';
import { inject, Signal } from '@angular/core';
import { TransferDto, TransfersControllerService } from '@api/client';
import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';

export const useTransfers = () =>
  signalStoreFeature(
    {
      props: {
        _activeAccountId: type<Signal<number | undefined>>(),
      },
    },
    withState({
      transfers: new Array<TransferDto>(),
    }),
    withProps(() => ({
      _transfersService: inject(TransfersControllerService),
    })),
    withMethods(store => {
      const setTransfers = (transfers: TransferDto[]) => patchState(store, { transfers });

      const loadTransfers = rxMethod<void>(
        pipe(
          switchMap(() =>
            store._transfersService.getTransfers(store._activeAccountId()).pipe(
              tapResponse({
                next: (transfers: TransferDto[]) => setTransfers(transfers),
                error: (_error: HttpErrorResponse) => undefined,
              }),
            ),
          ),
        ),
      );

      return { setTransfers, loadTransfers };
    }),
  );
